import { serializeQuery, type QueryObject } from './serializeQuery';
import type { SearchCriteria } from '../model/types';
import { checkInDateRange } from './fields/checkInDateRange';
import { hotels } from './fields/hotels';
import { nightRange } from './fields/nightRange';
import { resorts } from './fields/resorts';
import { toCountry } from './fields/toCountry';
import { touristGroup } from './fields/touristGroup';

/**
 * Query-string для поиска отельных офферов (порт
 * `components/hotelOffersSearch/router/toRouter.js`). Нет `fromCity` — в отельных
 * офферах город вылета отсутствует.
 */
export function getHotelOffersUrl(criteria: SearchCriteria, otherCriteria: QueryObject = {}): string {
  return serializeQuery({
    ...toCountry(criteria),
    ...resorts(criteria),
    ...checkInDateRange(criteria),
    ...nightRange(criteria),
    ...touristGroup(criteria),
    ...hotels(criteria),
    ...otherCriteria,
  });
}
